import { Navigate } from 'react-router-dom';

/**
 * Protège les routes du portail FFM.
 * Redirige vers /ffm-customlab/login si pas de session valide.
 * Optionnellement vérifie un rôle requis.
 */
export default function ProtectedPortalRoute({ session, requiredRole, children }) {
  if (!session) {
    return <Navigate to="/ffm-customlab/login" replace />;
  }

  if (requiredRole) {
    const roles = session.roles || [];
    const isAdmin = roles.includes('admin');
    if (!isAdmin && !roles.includes(requiredRole)) {
      // Pas le droit → rediriger vers commandes (premier onglet autorisé)
      return <Navigate to="/ffm-customlab/dashboard/commandes" replace />;
    }
  }

  return children;
}
